// extracted by mini-css-extract-plugin
export default {"mobileBreakpoint":"440px","headerBreakpoint":"780px","tabletBreakpoint":"1200px"};